export function getFinancialYearByDate(dateString) {
  let date = new Date(dateString)
  let year = date.getFullYear()
  let month = date.getMonth() + 1

  if (month >= 4) {
    return { text: `${year} Apr - ${year + 1} Mar`, value: `${year + 1}` }
  } else {
    return { text: `${year - 1} Apr - ${year} Mar`, value: `${year}` }
  }
}
